import { Box, Container, Stack, TextField, Typography } from "@mui/material";
import Top from "../Top";
import React, { useEffect } from "react";
import FeedbackIcon from '@mui/icons-material/Feedback';
import InsertCommentIcon from '@mui/icons-material/InsertComment';
import { useLocation } from "react-router-dom";
import api from "../../utils/api";
import Bottom from "../Bottom";


const SupportDetailQuestion = () => {
  const [boardInfo, setBoardInfo]: any = React.useState<Record<string, any>>({});

  const location = useLocation();
  const { state } = location;

  useEffect(() => {
    // state 가 없으면(새로고침·직접 URL 접근) 어떤 문의인지 알 수 없다.
    if (!state) return;

    api.post('customer/api/v1/CU_008_003', { qnaId: state.qnaId })
      .then(res => {
        console.log(res);
        res.data.status = res.data.status == true ? '답변완료' : '답변대기중';
        res.data.helper = res.data.answer == '' ? '답변대기중' : '관리자';
        setBoardInfo(res.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  return (
    <Container sx={{ bgcolor: '#F6F6F6', minHeight: '100vh', pt: 3, pb: 10, pl: 0, pr: 0, minWidth: 320 }}>
      <Top title="내 문의 내역" />

      <Box sx={{ p: 2, pt: 3, mt: 5 }}>
        <Box>
          <Box className='display_flex alignitem_center' sx={{ mb: 1 }}>
            <FeedbackIcon sx={{ fontSize: 40 }} />
            <Typography sx={{ fontSize: 16, ml: 1, fontWeight: 'bold' }}>
              {boardInfo && boardInfo.title}
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
            <Box
              sx={{
                maxWidth: 500,
                backgroundColor: '#fcfcfc',
                borderRadius: 2,
                p: 2,
                boxShadow: 1,
              }}
            >
              <Typography sx={{ fontSize: 14, whiteSpace: 'pre-wrap' }}>
                {boardInfo && boardInfo.question}
              </Typography>
            </Box>
            <Typography sx={{ fontSize: 12, color: '#888', ml: 1, alignSelf: 'flex-end' }}>{boardInfo && boardInfo.createDate}</Typography>
          </Box >
        </Box>

        <Stack alignItems={'flex-end'} sx={{ marginTop: '20px' }}>
          <Box className='display_flex alignitem_center' sx={{ mb: 1 }}>
            <Typography className="font_weight" sx={{ fontSize: 16, color: '#444', fontWeight: 'bold' }}>관리자</Typography>
            <InsertCommentIcon sx={{ fontSize: 40, ml: 1 }} />
          </Box>

          <Box
            sx={{ display: 'flex', alignItems: 'flex-end' }}
          >
            {
              boardInfo && boardInfo.answer != null
                ? <Typography sx={{ fontSize: 12, color: '#888', mr: 1, alignSelf: 'flex-end' }}>
                  {boardInfo.answeredDate}
                </Typography>
                : null
            }

            <Box
              sx={{
                maxWidth: 500,
                backgroundColor: '#FFFDED',
                borderRadius: 2,
                p: 2,
                boxShadow: 1,
                position: 'relative',
              }}>
              <Typography sx={{ fontSize: 14, whiteSpace: 'pre-wrap' }}>
                {boardInfo && boardInfo.answer || '답변 대기 중...'}
              </Typography>
            </Box>
          </Box>
        </Stack>
      </Box>

      <Bottom />
    </Container >
  );
}

export default SupportDetailQuestion;